import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSite } from '../content/SiteContext';
import { whatsappLink, track } from '../lib/contact';
import { Icon, WhatsAppIcon } from './ui';

// Mobile: bottom action bar. Desktop: floating WhatsApp button.
const StickyCTA = () => {
  const { BUSINESS } = useSite();
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin') || pathname.startsWith('/blog/create') || pathname.startsWith('/blog/edit')) return null;

  return (
    <>
      <div className="mobile-bar" role="region" aria-label="Quick actions">
        <a href={`tel:${BUSINESS.phone}`} className="mobile-bar__item" onClick={() => track('call_click', { source: 'mobile_bar' })}>
          <Icon name="phone" size={20} /><span>Call</span>
        </a>
        <a href={whatsappLink('Hi Quick Way, I would like to book a car wash.')} className="mobile-bar__item" target="_blank"
          rel="noopener noreferrer" onClick={() => track('whatsapp_click', { source: 'mobile_bar' })}>
          <WhatsAppIcon /><span>WhatsApp</span>
        </a>
        <a href={BUSINESS.playStore} className="mobile-bar__item mobile-bar__item--primary" target="_blank"
          rel="noopener noreferrer" onClick={() => track('app_store_click', { store: 'google_play', source: 'mobile_bar' })}>
          <Icon name="play" size={20} /><span>Get the app</span>
        </a>
      </div>
      <a href={whatsappLink('Hi Quick Way, I would like to book a car wash.')} className="whatsapp-float" target="_blank"
        rel="noopener noreferrer" aria-label="Chat with Quick Way on WhatsApp" onClick={() => track('whatsapp_click', { source: 'float' })}>
        <WhatsAppIcon size={28} />
      </a>
    </>
  );
};

export default StickyCTA;
